import { render } from "./TextSimple.vue?vue&type=template&id=f45f9bf2"
import script from "./TextSimple.vue?vue&type=script&lang=js"
export * from "./TextSimple.vue?vue&type=script&lang=js"

import "./TextSimple.vue?vue&type=style&index=0&id=f45f9bf2&lang=scss"
script.render = render

export default script